import { Cake } from "@mui/icons-material";
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import { SubtypeDefinition } from "../actionModule";
import { PropertyTypes } from "../editor/subtypeEditorTypes";
import { Subtype } from "./subtype";
import BirthdayBonusEditorPreview from "../../../components/actionModules/subtypes/birthdayBonus/BirthdayBonusEditorPreview";

export const BirthdayBonusSubtype: SubtypeDefinition = {
    name: "actionModules.subtypes.birthdayBonus.name",
    type: Subtype.BirthdayBonusModuleSubtype,
    icon: <Cake />,
    toolboxPlaceholder: () => <SubtypeToolboxPlaceholderScaffold
        icon={<Cake />}
        name="actionModules.subtypes.birthdayBonus.name" />,
    editorPreview: BirthdayBonusEditorPreview,
    editableProperties: [
        {
            displayName: "actionModules.subtypes.birthdayBonus.bonusReward",
            name: "bonusRewardPoints",
            propertyType: PropertyTypes.integer,
            defaultValue: 600,
        }
    ]
};